var map = {
	"./depNumber.svg": 88564,
	"./frequency.svg": 18876,
	"./fsAmount.svg": 49234,
	"./game.svg": 69175,
	"./hourglass.svg": 78267,
	"./info.svg": 82265,
	"./maxBonus.svg": 51373,
	"./maxCashout.svg": 83774,
	"./maxWinFs.svg": 24183,
	"./minDep.svg": 89939,
	"./prize.svg": 48075,
	"./rtp.svg": 76823,
	"./tick.svg": 78175,
	"./wager.svg": 18143,
	"./wagerDark.svg": 93342
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11425;